<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="KeHuList" data-title="交易流水">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showChange = true;
        "
      >
        充值/扣款
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column prop="id" label="ID" :width="120" align="center" />
        <el-table-column
          prop="type_name"
          label="类型"
          :width="120"
          align="center"
        />
        <el-table-column
          prop="money"
          label="金额"
          :formatter="$tab_MoneyFormat"
          align="right"
          :width="120"
        >
          <template #default="{ row }">
            <div class="flex justify-end">
              <c_money
                :key="row.money"
                :value="row.type == 0 ? row.money : 0 - row.money"
                :prefix="false"
                :color="row.type == 0 ? '#008000' : '#f00'"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="附件"
          prop="remark"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <c_UploadFile
              v-if="row.attachment?.length > 0"
              :key="row.attachment"
              :value="row.attachment"
              :showAdd="false"
              :showText="true"
            />
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column label="创建信息">
          <template #default="{ row }">
            <div class="flex items-center text-gray-400 text-xs gap-x-2 mt-2">
              <text class="text-sm text-gray-600">
                {{ row?.add_admin_name }}
              </text>
              <text>{{ row?.add_department_name }}</text>
              <text class="ml-1">{{ row?.create_time }} 创建</text>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showChange"
    title="充值/扣款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showChange = false;
      }
    "
    :width="400"
  >
    <c_change
      :bill_unit_id="props.bill_unit_id"
      @close="
        (refresh) => {
          state.showChange = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { billunit_balancelog_page } from "@/http/billunit";
import c_change from "../../ChangeBalance.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    bill_unit_id: Number,
  },
  components: {
    c_change,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.bill_unit_id = props.bill_unit_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      billunit_balancelog_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };
    return { state, props, onLoad };
  },
};
</script>

<style lang="scss" scoped></style>
